import { derived, type Readable } from 'svelte/store';
import type { RouteName } from '$router';
import { BaseViewModel, type BaseViewModelInterface } from '$services';
import type { BaseMetaTags } from '@shared/svelte-kit';

export type HeadTagsViewModelInterface = {
	readonly metadata: Readable<BaseMetaTags>;
} & BaseViewModelInterface;

class HeadTagsViewModel
	extends BaseViewModel
	implements HeadTagsViewModelInterface
{
	get metadata(): Readable<BaseMetaTags> {
		return derived(
			[
				this.getR('appService', 'title', undefined),
				this.getR('routerService', 'currentRoute', undefined),
			],
			([appTitle, currentRoute]) => {
				return {
					description:
						'MailVideo makes it easy to record and share videos by email with just a few clicks.',
					keywords: ['video'],
					title: this._getTitle({ appTitle, currentRoute }),
				};
			},
		);
	}

	private _getTitle(options: {
		appTitle?: string;
		currentRoute?: RouteName;
	}): string {
		// TODO use currentRoute to set the title

		return options.appTitle ?? 'MailVideo';
	}
}

export const getHeadTagsViewModel = () =>
	new HeadTagsViewModel({
		className: 'HeadTagsViewModel',
	});
